module.exports = __webpack_public_path__ + "static/media/portfolio-2.2a45e00b.jpg";